module.exports = __webpack_public_path__ + "static/media/placeholders_lr.334feb31.jpg";